module.exports = __webpack_public_path__ + "static/media/sort-amount-up.631223b6.svg";